import { SetLayout } from "../../shared";
import dynamic from "next/dynamic";

const Skeleton = dynamic(() => import("react-loading-skeleton"), {
    ssr: false,
});

export const SetCollectionsSkeleton = () => {
    return (
        <SetLayout>
            <div className="flex flex-col w-i">
                <Skeleton width={"100%"} height={"80px"} className="mb-3 " />
                <Skeleton
                    width={"98px"}
                    height={"22px"}
                    className="mb-1 ml-4"
                />
                <Skeleton
                    width={"274px"}
                    height={"49px"}
                    className="mb-1 ml-4"
                />
                <Skeleton
                    width={"168px"}
                    height={"22px"}
                    className="mb-8 ml-4"
                />
                <div className="px-4 mb-8">
                    <Skeleton
                        width={"100%"}
                        height={"388px"}
                        className="mx-auto mb-8"
                    />
                </div>
                <div className="px-4 mb-8">
                    <Skeleton
                        width={"100%"}
                        height={"388px"}
                        className="mx-auto mb-8"
                    />
                </div>
                <div className="px-4 mb-8">
                    <Skeleton
                        width={"100%"}
                        height={"388px"}
                        className="mx-auto mb-8"
                    />
                </div>
            </div>
        </SetLayout>
    );
};
